'use client';

import { useSearchStore } from '@/stores/search-store';
import { SearchPageSkeleton } from '@/tenants/dgr/search/SearchPageSkeleton';

export function SearchTransitionOverlay() {
  const { isTransitioning, pendingQuery } = useSearchStore();

  if (!isTransitioning) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-dgr-cream flex flex-col animate-in fade-in duration-150">
      <SearchPageSkeleton query={pendingQuery ?? undefined} />
    </div>
  );
}
